/** ------------------正则表达式---------------- **/

// 名称中的特殊符号
const RegSymbol = /\\|\/|\*|\?|<|>|\||:|'|"|#|%/

export {
  RegSymbol
}
